(function () {
  "use strict";

  const CONFIG = {
    klaviyoStartFormId: "SdZU4h",

    rewardCodes: [
      { code: "PASCUA2026S", label: "Suscriptores" },
      { code: "PASCUA2026", label: "No suscriptores" }
    ],

    totalEggsRequired: 6,

    events: {
      started: "Easter Hunt Started",
      eggFound: "Easter Egg Found",
      completed: "Easter Hunt Completed"
    },

    copy: {
      startMessage: "¡Empieza la búsqueda! Encuentra los 6 huevos escondidos por la web.",
      completedTitle: "¡Has completado la búsqueda!",
      completedMessage: "Introduce el siguiente código en el carrito para hacer efectivo tu descuento:",
      widgetTitle: "🎉 Obtener mi código",
      widgetSubtitle: " "
    },

    allowReplay: false,
    showProgressWidget: true,
    debug: false,

    ui: {
      eggDesktopWidth: 70,
      eggDesktopHeight: 110,
      eggMobileWidth: 60,
      eggMobileHeight: 90,
      eggLeftOffset: 16,
      eggBottomOffset: 76,
      counterLeftOffset: 16,
      counterBottomOffset: 16
    },

    excludedPaths: [
      "/cart",
      "/checkout",
      "/account",
      "/account/login",
      "/account/register",
      "/search",
      "/policies/privacy-policy",
      "/policies/refund-policy",
      "/policies/shipping-policy",
      "/policies/terms-of-service"
    ],

    eggImages: [
      window.EASTER_EGG_ASSETS?.egg1,
      window.EASTER_EGG_ASSETS?.egg2,
      window.EASTER_EGG_ASSETS?.egg3,
      window.EASTER_EGG_ASSETS?.egg4,
      window.EASTER_EGG_ASSETS?.egg5,
      window.EASTER_EGG_ASSETS?.egg6
    ],

    completedBgVideo: window.EASTER_EGG_ASSETS?.completedBgVideo || null,
    openFormButtonSelector: ".open-klaviyo-form"
  };

  const STORAGE = {
    active: "eeh_active",
    completed: "eeh_completed",
    rewardShown: "eeh_reward_shown",
    startedAt: "eeh_started_at",
    foundEggs: "eeh_found_eggs",
    visitedValidPages: "eeh_visited_valid_pages",
    currentEggPage: "eeh_current_egg_page",
    currentEggIndex: "eeh_current_egg_index",
    klaviyoLaunched: "eeh_klaviyo_launched"
  };

  function log() {
    if (CONFIG.debug) console.log("[EasterEggHunt]", ...arguments);
  }

  function normalizePath(path) {
    return (path || "").replace(/\/+$/, "") || "/";
  }

  function getCurrentPath() {
    return normalizePath(window.location.pathname);
  }

  function getJsonArray(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || "[]");
    } catch {
      return [];
    }
  }

  function setJsonArray(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  function isActive() {
    return localStorage.getItem(STORAGE.active) === "true";
  }

  function isCompleted() {
    return localStorage.getItem(STORAGE.completed) === "true";
  }

  function getFoundEggs() {
    return getJsonArray(STORAGE.foundEggs);
  }

  function setFoundEggs(value) {
    setJsonArray(STORAGE.foundEggs, value);
  }

  function getVisitedValidPages() {
    return getJsonArray(STORAGE.visitedValidPages);
  }

  function setVisitedValidPages(value) {
    setJsonArray(STORAGE.visitedValidPages, value);
  }

  function getCurrentEggPage() {
    return localStorage.getItem(STORAGE.currentEggPage) || "";
  }

  function setCurrentEggPage(path) {
    localStorage.setItem(STORAGE.currentEggPage, path || "");
  }

  function clearCurrentEggPage() {
    localStorage.removeItem(STORAGE.currentEggPage);
  }

  function getCurrentEggIndex() {
    const value = localStorage.getItem(STORAGE.currentEggIndex);
    return value ? parseInt(value, 10) : -1;
  }

  function setCurrentEggIndex(index) {
    localStorage.setItem(STORAGE.currentEggIndex, String(index));
  }

  function clearCurrentEggIndex() {
    localStorage.removeItem(STORAGE.currentEggIndex);
  }

  function isExcludedPath(path) {
    const current = normalizePath(path);
    return CONFIG.excludedPaths.some(function (excludedPath) {
      return normalizePath(excludedPath) === current;
    });
  }

  function isValidGamePage(path) {
    const current = normalizePath(path);
    return !!current && !isExcludedPath(current);
  }

  function shouldShowEggOnVisit(visitNumber) {
    if (visitNumber === 1) return true;
    if (visitNumber === 2) return false;
    return true;
  }

  function injectStyles() {
    if (document.getElementById("eeh-styles")) return;

    const style = document.createElement("style");
    style.id = "eeh-styles";
    style.innerHTML = `
      @keyframes eeh-bounce {
        0%, 100% { transform: translateY(0) scale(1); }
        50% { transform: translateY(-7px) scale(1.03); }
      }

      @keyframes eeh-shimmer {
        0% { left: -75%; }
        100% { left: 125%; }
      }

      @keyframes eeh-confetti-fall {
        0% {
          transform: translateY(-20px) rotate(0deg);
          opacity: 0;
        }
        10% {
          opacity: 1;
        }
        100% {
          transform: translateY(110vh) rotate(720deg);
          opacity: 0;
        }
      }

      .eeh-egg-button {
        position: fixed;
        left: ${CONFIG.ui.eggLeftOffset}px;
        bottom: ${CONFIG.ui.eggBottomOffset}px;
        z-index: 999999;
        width: ${CONFIG.ui.eggDesktopWidth}px;
        height: ${CONFIG.ui.eggDesktopHeight}px;
        border: 0;
        padding: 0;
        background: transparent;
        cursor: pointer;
        animation: eeh-bounce 1.6s infinite;
        transition: transform 0.2s ease;
      }

      .eeh-egg-button:hover {
        transform: scale(1.08);
      }

      .eeh-egg-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        pointer-events: none;
        user-select: none;
        -webkit-user-drag: none;
        filter: drop-shadow(0 8px 16px rgba(0,0,0,0.18));
      }

      #eeh-progress-widget {
        position: fixed;
        left: ${CONFIG.ui.counterLeftOffset}px;
        bottom: ${CONFIG.ui.counterBottomOffset}px;
        z-index: 999998;
        display: flex;
        align-items: center;
        gap: 8px;
        background: #b3d970;
        color: #304807;
        border-radius: 999px;
        padding: 10px 14px;
        font-size: 14px;
        font-weight: 600;
        box-shadow: 0 8px 24px rgba(0,0,0,0.18);
      }

      #eeh-progress-widget.is-clickable {
        position: fixed;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.2s ease, opacity 0.2s ease;
      }

      #eeh-progress-widget.is-clickable:hover {
        transform: scale(1.04);
        opacity: 0.95;
      }

      #eeh-progress-widget.is-clickable::after {
        content: "";
        position: absolute;
        top: 0;
        left: -75%;
        width: 50%;
        height: 100%;
        background: linear-gradient(
          120deg,
          transparent,
          rgba(255, 255, 255, 0.4),
          transparent
        );
        transform: skewX(-20deg);
        animation: eeh-shimmer 2.8s infinite;
      }

      .eeh-widget-final {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
      }

      .eeh-widget-title {
        font-weight: 700;
        font-size: 14px;
      }

      .eeh-widget-sub {
        font-size: 12px;
        opacity: 0.75;
      }

      #eeh-toast {
        position: fixed;
        left: 50%;
        bottom: 16px;
        transform: translateX(-50%) translateY(20px);
        opacity: 0;
        z-index: 1000002;
        background: #111;
        color: #fff;
        padding: 12px 16px;
        border-radius: 12px;
        font-size: 14px;
        box-shadow: 0 8px 24px rgba(0,0,0,0.18);
        max-width: calc(100vw - 32px);
        text-align: center;
        transition:
          opacity 0.25s ease,
          transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      }

      #eeh-toast.is-visible {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }

      .eeh-confetti {
        position: fixed;
        top: 0;
        width: 8px;
        height: 14px;
        z-index: 1000003;
        pointer-events: none;
        animation: eeh-confetti-fall linear forwards;
      }

      #eeh-reward-overlay {
        position: fixed;
        inset: 0;
        z-index: 1000000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        overflow: hidden;
      }

      #eeh-reward-bg {
        display: none;
      }

      @media (min-width: 768px) {
        #eeh-reward-bg {
          display: block;
          position: absolute;
          inset: 0;
          overflow: hidden;
          z-index: 1;
          opacity: 0;
          transform: scale(1.06);
          filter: blur(8px);
          transition:
            opacity 800ms ease,
            transform 900ms ease,
            filter 900ms ease;
        }

        #eeh-reward-overlay.is-visible #eeh-reward-bg {
          opacity: 1;
          transform: scale(1);
          filter: blur(0px);
        }

        #eeh-bg-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        #eeh-reward-bg::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            rgba(0,0,0,0.45),
            rgba(0,0,0,0.25)
          );
        }
      }

      #eeh-reward-modal {
        position: relative;
        z-index: 2;
        width: 100%;
        max-width: 480px;
        background: #fff;
        border-radius: 4px;
        padding: 24px;
        text-align: center;
        box-shadow: 0 20px 50px rgba(0,0,0,0.22);
        opacity: 0;
        transform: translateY(30px) scale(0.96);
        transition:
          opacity 500ms cubic-bezier(0.22, 1, 0.36, 1) 200ms,
          transform 500ms cubic-bezier(0.22, 1, 0.36, 1) 200ms;
      }

      #eeh-reward-overlay.is-visible #eeh-reward-modal {
        opacity: 1;
        transform: translateY(0) scale(1);
      }

      #eeh-reward-modal h3 {
        margin: 0 0 10px;
        font-size: 28px;
        line-height: 1.15;
        font-family: "Montserrat", sans-serif;
        font-weight: 700;
      }

      #eeh-reward-modal p {
        margin: 0 0 14px;
        color: #333;
        line-height: 1.5;
      }

      .eeh-codes-wrapper {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin: 16px 0 20px;
      }

      .eeh-code-block {
        background: #f8f8f8;
        padding: 12px;
        border-radius: 12px;
        text-align: left;
      }

      .eeh-code-label {
        margin-bottom: 6px;
        font-size: 14px;
        color: #4e3629;
        font-family: "Montserrat", sans-serif;
        font-weight: normal;
      }

      .eeh-code-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }

      .eeh-code-value {
        flex: 1;
        background: #50372a;
        color: #fff;
        border-radius: 8px;
        padding: 10px 12px 8px;
        text-align: center;
        font-size: 18px;
        font-weight: 800;
        letter-spacing: 1px;
        line-height: 1.4em;
      }

      .eeh-copy-btn {
        border: 0;
        border-radius: 8px;
        padding: 10px 12px 8px;
        background: #b3d970;
        color: #304807;
        font-weight: 500;
        cursor: pointer;
        white-space: nowrap;
      }

      .eeh-copy-btn:hover {
        opacity: 0.9;
      }

      .eeh-btn-row {
        display: flex;
        gap: 10px;
        justify-content: center;
        flex-wrap: wrap;
      }

      .eeh-btn {
        border: 0;
        border-radius: 8px;
        padding: 12px 16px;
        cursor: pointer;
        font-weight: 700;
      }

      .eeh-btn-secondary {
        background: #eee;
        color: #111;
      }

      @media (max-width: 767px) {
        .eeh-egg-button {
          width: ${CONFIG.ui.eggMobileWidth}px;
          height: ${CONFIG.ui.eggMobileHeight}px;
          left: 12px;
          bottom: 70px;
        }

        #eeh-progress-widget {
          left: 10px;
          bottom: 15px;
          font-size: 12px;
          padding: 9px 12px;
        }

        .eeh-code-row {
          flex-direction: column;
          align-items: stretch;
        }

        .eeh-copy-btn {
          width: 100%;
        }

        #eeh-reward-overlay {
          padding: 16px;
        }

        #eeh-reward-modal {
          max-width: 100%;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function showToast(message) {
    injectStyles();

    const existing = document.getElementById("eeh-toast");
    if (existing) existing.remove();

    const toast = document.createElement("div");
    toast.id = "eeh-toast";
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add("is-visible");
    });

    setTimeout(function () {
      toast.classList.remove("is-visible");
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 5000);
  }

  function launchConfetti() {
    const colors = ["#FFD700", "#FF6B6B", "#6BCB77", "#4D96FF", "#FF9F1C"];
    const pieces = 60;

    for (let i = 0; i < pieces; i++) {
      const confetti = document.createElement("div");
      confetti.className = "eeh-confetti";

      const left = Math.random() * 100;
      const duration = 2 + Math.random() * 2;
      const delay = Math.random() * 0.5;

      confetti.style.left = left + "vw";
      confetti.style.backgroundColor =
        colors[Math.floor(Math.random() * colors.length)];
      confetti.style.animationDuration = duration + "s";
      confetti.style.animationDelay = delay + "s";

      document.body.appendChild(confetti);

      setTimeout(function () {
        confetti.remove();
      }, (duration + delay) * 1000);
    }
  }

  function trackKlaviyoEvent(eventName, properties) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === "function") {
        window.klaviyo.track(eventName, properties || {});
        log("Tracked via klaviyo.track:", eventName, properties);
        return;
      }

      if (window._learnq && typeof window._learnq.push === "function") {
        window._learnq.push(["track", eventName, properties || {}]);
        log("Tracked via _learnq.push:", eventName, properties);
      }
    } catch (error) {
      log("Klaviyo track error", error);
    }
  }

  function setCompletedWidgetState(widget) {
    widget.innerHTML = `
      <div class="eeh-widget-final">
        <div class="eeh-widget-title">${CONFIG.copy.widgetTitle}</div>
        <div class="eeh-widget-sub">${CONFIG.copy.widgetSubtitle}</div>
      </div>
    `;
    widget.classList.add("is-clickable");
    widget.setAttribute("role", "button");
    widget.setAttribute("tabindex", "0");
    widget.setAttribute("aria-label", "Ver código de descuento");

    widget.onclick = function () {
      showRewardModal(true);
    };

    widget.onkeydown = function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        showRewardModal(true);
      }
    };
  }

  function setProgressWidgetState(widget, foundCount) {
    widget.innerHTML = `🥚 ${foundCount}/${CONFIG.totalEggsRequired}`;
    widget.classList.remove("is-clickable");
    widget.removeAttribute("role");
    widget.removeAttribute("tabindex");
    widget.removeAttribute("aria-label");
    widget.onclick = null;
    widget.onkeydown = null;
  }

  function renderProgressWidget() {
    if (!CONFIG.showProgressWidget) return;

    injectStyles();

    let widget = document.getElementById("eeh-progress-widget");
    if (!widget) {
      widget = document.createElement("div");
      widget.id = "eeh-progress-widget";
      document.body.appendChild(widget);
    }

    const foundCount = getFoundEggs().length;
    const completed = isCompleted();

    if (!isActive() && foundCount === 0 && !completed) {
      widget.style.display = "none";
      return;
    }

    widget.style.display = "flex";

    if (completed) {
      setCompletedWidgetState(widget);
    } else {
      setProgressWidgetState(widget, foundCount);
    }
  }

  function updateProgressWidget() {
    const widget = document.getElementById("eeh-progress-widget");
    if (!widget) {
      renderProgressWidget();
      return;
    }

    const foundCount = getFoundEggs().length;
    const completed = isCompleted();

    if (completed) {
      setCompletedWidgetState(widget);
    } else {
      setProgressWidgetState(widget, foundCount);
    }
  }

  function closeRewardModal() {
    const overlay = document.getElementById("eeh-reward-overlay");
    if (!overlay) return;

    overlay.classList.remove("is-visible");

    setTimeout(function () {
      if (overlay && overlay.parentNode) {
        overlay.remove();
      }
    }, 450);
  }

  function showRewardModal(forceOpen) {
    const existingOverlay = document.getElementById("eeh-reward-overlay");
    if (existingOverlay) return;

    if (!forceOpen && localStorage.getItem(STORAGE.rewardShown) === "true") {
      renderProgressWidget();
      return;
    }

    injectStyles();

    const codesHtml = CONFIG.rewardCodes
      .map(function (item) {
        return `
          <div class="eeh-code-block">
            <div class="eeh-code-label">${item.label}</div>
            <div class="eeh-code-row">
              <div class="eeh-code-value">${item.code}</div>
              <button class="eeh-copy-btn" data-code="${item.code}">Copiar</button>
            </div>
          </div>
        `;
      })
      .join("");

    const isDesktop = window.matchMedia("(min-width: 768px)").matches;
    const videoWebm = CONFIG.completedBgVideo;

    const hasCompletedBg =
      isDesktop &&
      typeof videoWebm === "string" &&
      videoWebm.trim() !== "";

    const videoMarkup = hasCompletedBg
      ? `
        <div id="eeh-reward-bg" aria-hidden="true">
          <video
            id="eeh-bg-video"
            autoplay
            muted
            loop
            playsinline
            preload="auto"
            disablepictureinpicture
          >
            <source src="${videoWebm}" type="video/webm">
          </video>
        </div>
      `
      : "";

    const overlay = document.createElement("div");
    overlay.id = "eeh-reward-overlay";
    overlay.innerHTML = `
      ${videoMarkup}
      <div id="eeh-reward-modal" role="dialog" aria-modal="true" aria-labelledby="eeh-reward-title">
        <div style="font-size:52px; margin:25px 0;">🎉</div>
        <h3 id="eeh-reward-title">${CONFIG.copy.completedTitle}</h3>
        <p>${CONFIG.copy.completedMessage}</p>
        <div class="eeh-codes-wrapper">
          ${codesHtml}
        </div>
        <div class="eeh-btn-row">
          <button class="eeh-btn eeh-btn-secondary" id="eeh-close-reward-btn">Cerrar</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      overlay.classList.add("is-visible");
      launchConfetti();
    });

    document.querySelectorAll(".eeh-copy-btn").forEach(function (button) {
      button.addEventListener("click", async function () {
        const code = button.getAttribute("data-code");

        try {
          await navigator.clipboard.writeText(code);
          const originalText = button.textContent;
          button.textContent = "Copiado ✓";
          showToast("✅ Código copiado");

          setTimeout(function () {
            button.textContent = originalText;
          }, 2000);
        } catch {
          showToast("No se ha podido copiar automáticamente");
        }
      });
    });

    document
      .getElementById("eeh-close-reward-btn")
      .addEventListener("click", function () {
        closeRewardModal();
      });

    localStorage.setItem(STORAGE.rewardShown, "true");
    renderProgressWidget();
  }

  function getEggImageForCurrentPage() {
    const currentPath = getCurrentPath();
    const eggPage = getCurrentEggPage();
    const eggIndex = getCurrentEggIndex();

    if (eggPage !== currentPath) return null;
    if (eggIndex < 0) return null;

    return CONFIG.eggImages[eggIndex] || null;
  }

  function renderEggIfNeeded() {
    const existingEgg = document.getElementById("eeh-egg");
    const eggImage = getEggImageForCurrentPage();

    if (!isActive() || isCompleted() || !eggImage) {
      if (existingEgg) existingEgg.remove();
      return;
    }

    if (existingEgg) existingEgg.remove();

    injectStyles();

    const egg = document.createElement("button");
    egg.id = "eeh-egg";
    egg.type = "button";
    egg.className = "eeh-egg-button";
    egg.setAttribute("aria-label", "Huevo de Pascua");
    egg.innerHTML = `
      <img
        src="${eggImage}"
        alt="Huevo de Pascua"
        class="eeh-egg-image"
        loading="eager"
        decoding="async"
      />
    `;

    egg.addEventListener("click", function () {
      markEggAsFound();
      egg.remove();
    });

    document.body.appendChild(egg);
  }

  function registerCurrentPageVisit() {
    if (!isActive() || isCompleted()) return;

    const currentPath = getCurrentPath();
    if (!isValidGamePage(currentPath)) return;

    const visitedPages = getVisitedValidPages();
    if (visitedPages.includes(currentPath)) return;

    visitedPages.push(currentPath);
    setVisitedValidPages(visitedPages);

    const visitNumber = visitedPages.length;
    const foundCount = getFoundEggs().length;

    if (foundCount >= CONFIG.totalEggsRequired) return;

    if (shouldShowEggOnVisit(visitNumber)) {
      setCurrentEggPage(currentPath);
      setCurrentEggIndex(foundCount);
      log("Egg assigned to page", currentPath, "visit", visitNumber, "eggIndex", foundCount);
    } else {
      if (getCurrentEggPage() === currentPath) {
        clearCurrentEggPage();
        clearCurrentEggIndex();
      }
      log("No egg on page", currentPath, "visit", visitNumber);
    }
  }

  function markEggAsFound() {
    const currentPath = getCurrentPath();
    const eggPage = getCurrentEggPage();
    const eggIndex = getCurrentEggIndex();

    if (!eggPage || eggPage !== currentPath) return;
    if (eggIndex < 0) return;

    const foundEggs = getFoundEggs();
    if (foundEggs.includes(currentPath)) return;

    foundEggs.push(currentPath);
    setFoundEggs(foundEggs);

    const totalFound = foundEggs.length;
    const imageUsed = CONFIG.eggImages[eggIndex] || "";

    trackKlaviyoEvent(CONFIG.events.eggFound, {
      egg_number: totalFound,
      egg_path: currentPath,
      egg_image: imageUsed,
      eggs_found: totalFound,
      eggs_total: CONFIG.totalEggsRequired
    });

    clearCurrentEggPage();
    clearCurrentEggIndex();

    updateProgressWidget();
    showToast(`🎉 ¡Has encontrado ${totalFound}/${CONFIG.totalEggsRequired} huevos! Continúa...`);

    if (totalFound >= CONFIG.totalEggsRequired) {
      completeGame();
    }
  }

  function completeGame() {
    localStorage.setItem(STORAGE.completed, "true");
    localStorage.setItem(STORAGE.active, "false");
    clearCurrentEggPage();
    clearCurrentEggIndex();

    trackKlaviyoEvent(CONFIG.events.completed, {
      eggs_found: getFoundEggs().length,
      reward_codes: CONFIG.rewardCodes.map(function (item) {
        return item.code;
      }),
      completed_at: new Date().toISOString()
    });

    const egg = document.getElementById("eeh-egg");
    if (egg) egg.remove();

    updateProgressWidget();
    showRewardModal(false);
  }

  function startGame(source) {
    if (isActive()) return;

    if (isCompleted() && !CONFIG.allowReplay) {
      log("Game already completed, replay disabled.");
      return;
    }

    localStorage.setItem(STORAGE.active, "true");
    localStorage.setItem(STORAGE.completed, "false");
    localStorage.setItem(STORAGE.rewardShown, "false");
    localStorage.setItem(STORAGE.startedAt, new Date().toISOString());

    setFoundEggs([]);
    setVisitedValidPages([]);
    clearCurrentEggPage();
    clearCurrentEggIndex();

    showToast(CONFIG.copy.startMessage);

    trackKlaviyoEvent(CONFIG.events.started, {
      source: source || "manual",
      started_at: localStorage.getItem(STORAGE.startedAt)
    });

    registerCurrentPageVisit();
    renderProgressWidget();
    renderEggIfNeeded();
    log("Game started");
  }

  function resetGame() {
    Object.values(STORAGE).forEach(function (key) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    ["eeh-egg", "eeh-reward-overlay", "eeh-progress-widget", "eeh-toast"].forEach(function (id) {
      const element = document.getElementById(id);
      if (element) element.remove();
    });

    log("Game reset");
  }

  function openKlaviyoForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", CONFIG.klaviyoStartFormId]);
  }

  function openKlaviyoFormIfAllowed() {
    if (sessionStorage.getItem(STORAGE.klaviyoLaunched) === "true") return;
    if (isActive() || isCompleted()) return;

    openKlaviyoForm();
    sessionStorage.setItem(STORAGE.klaviyoLaunched, "true");

    log("Klaviyo form opened once");
  }

  function bindKlaviyoFormStartListener() {
    window.addEventListener("klaviyoForms", function (event) {
      const detail = event && event.detail ? event.detail : {};
      const formId = String(detail.formId || "");
      const eventType = String(detail.type || "");

      console.log("[KlaviyoForms]", detail);

      if (formId !== String(CONFIG.klaviyoStartFormId)) return;
      if (isActive() || isCompleted()) return;

      if (eventType === "submit" || eventType === "stepSubmit") {
        startGame("klaviyo_form_submit");
      }
    });
  }

  function handleRouteChange() {
    if (!isActive() || isCompleted()) {
      renderProgressWidget();
      renderEggIfNeeded();
      return;
    }

    registerCurrentPageVisit();
    renderProgressWidget();
    renderEggIfNeeded();
  }

  function bindRouteWatcher() {
    let lastUrl = window.location.href;

    setInterval(function () {
      const currentUrl = window.location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        handleRouteChange();
      }
    }, 400);
  }

  function bindResetShortcut() {
    document.addEventListener("keydown", function (event) {
      if (event.shiftKey && event.altKey && event.key.toLowerCase() === "r") {
        resetGame();
        showToast("Juego reiniciado");
      }
    });
  }

  function bindExternalOpenButtons() {
    document.addEventListener("click", function (event) {
      const trigger = event.target.closest(CONFIG.openFormButtonSelector);
      if (!trigger) return;

      event.preventDefault();

      if (isCompleted()) {
        showRewardModal(true);
        return;
      }

      openKlaviyoForm();
      sessionStorage.setItem(STORAGE.klaviyoLaunched, "true");
    });
  }

  function boot() {
    bindKlaviyoFormStartListener();
    bindExternalOpenButtons();
    bindRouteWatcher();
    bindResetShortcut();

    renderProgressWidget();
    renderEggIfNeeded();
    openKlaviyoFormIfAllowed();

    if (isActive() && !isCompleted()) {
      registerCurrentPageVisit();
      renderEggIfNeeded();
    }

    if (isCompleted()) {
      renderProgressWidget();
    }

    log("Boot complete");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();